/*
 * ShareAppButton — abre un modal con el bloque de descarga (QR + tarjetas)
 * accesible desde la sidebar dentro de la app. Útil para que Marco enseñe
 * el QR a un compañero sin cerrar sesión.
 */
import React, { useState } from 'react';
import { QrCode, X } from 'lucide-react';
import DownloadCTA from './DownloadCTA';

const ShareAppButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="px-3 pb-2">
        <button onClick={() => setOpen(true)} data-testid="btn-share-app"
          className="w-full flex items-center justify-center gap-1.5 text-white/50 hover:text-[#A3FF12] hover:bg-white/5 text-[11px] font-bold py-1.5 rounded-lg transition-colors">
          <QrCode size={12}/> Compartir descarga
        </button>
      </div>

      {open && (
        <div className="fixed inset-0 z-[1000] bg-black/80 backdrop-blur flex items-center justify-center p-4"
          onClick={() => setOpen(false)} data-testid="share-app-modal">
          <div onClick={(e) => e.stopPropagation()} className="relative">
            <button onClick={() => setOpen(false)} data-testid="btn-close-share"
              className="absolute -top-3 -right-3 z-10 bg-[#0a0a0a] border border-white/15 text-white/70 hover:text-white rounded-full p-1.5"
              aria-label="Cerrar">
              <X size={16}/>
            </button>
            <DownloadCTA forceShow/>
          </div>
        </div>
      )}
    </>
  );
};

export default ShareAppButton;
